<template>
  <div :class="`report-tempalte-wrapper mb-1 ${inSidepage ? '' : 'no-edit'}`" ref="templateContent">
    <!-- 月报 系统报表 -->
    <div class="report-content" v-if="wholeType === 'month' && type === 'system'" title="此内容不支持编辑">
      <p style="text-indent:2em">此邮件为公有云费用相关的报告，{{ 'YYYY' | bracketFilter }}年{{ 'MM' | bracketFilter }}月费用报告如下：</p>
      <table cellspacing="0" cellpadding="5" width="100%" style="color: #606266;border: solid 1px #ccc;">
        <tbody>
          <tr style="background: #AEE2FF;border: 1px solid #AEE2FF;color:black">
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">云账号</th>
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">平台</th>
            <th align="right" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">费用</th>
            <th align="left" style="border-bottom:solid 1px #ccc">占比</th>
          </tr>
          <tr style="font-size: 14px">
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">test-account</td>
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">某平台</td>
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;text-align:right">{{ currencySign }} 123236.26</td>
            <td style="border-bottom: 1px solid #ccc;">50%</td>
          </tr>
          <tr style="font-size: 14px">
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">test-account2</td>
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">某平台</td>
            <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;text-align:right">{{ currencySign }} 123236.26</td>
            <td style="border-bottom: 1px solid #ccc;">50%</td>
          </tr>
        </tbody>
      </table>
      <p style="text-indent:2em">近六个月公有云消费情况如下图所示：</p>
      <img :src="PublicCostImg" alt="近六个月公有云消费" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <p style="text-indent:2em">项目费用TOP10如下表所示：</p>
      <table cellspacing="0" cellpadding="5" width="100%" style="color: #606266;border: solid 1px #ccc;">
        <tbody>
          <tr style="background: #AEE2FF;border: 1px solid #AEE2FF;color:black">
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">项目</th>
            <th align="rigth" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">管理员</th>
            <th align="left" style="border-bottom:solid 1px #ccc">费用</th>
          </tr>
          <template v-for="item in 10">
            <tr style="font-size: 14px" :key="item">
              <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">project1</td>
              <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc">Admin1</td>
              <td style="border-bottom: 1px solid #ccc;text-align:right">{{ currencySign }} 10023.2</td>
            </tr>
          </template>
        </tbody>
      </table>
      <!-- <div class="mask">此内容不可编辑！</div> -->
    </div>
    <!-- 月报 域和项目报表 -->
    <div class="report-content" v-if="wholeType === 'month' && (type === 'domain' || type === 'project')" title="此内容不支持编辑">
      <p style="text-indent:2em">此邮件为您所属的{{type === 'project' ? '项目' : '域'}} {{type === 'project' ? 'project' : 'domain' | bracketFilter}} 在{{'YYYY' | bracketFilter}}年{{'MM' | bracketFilter}}月费用及资源信息：</p>
      <p style="font-size:22px;font-weight:bold;text-decoration:underline">账单费用</p>
      <p style="text-indent:2em">{{'MM' | bracketFilter}}月费用{{ currencySign }}{{'xx' | bracketFilter}}, 近6个月消费情况如下图所示:</p>
      <img :src="PublicCostImg" alt="月费用" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <p style="text-indent:2em;color:red">注：若有其它币种账单将以上述格式同步展示（此内容不会保存到模板中）</p>
      <p style="font-size:22px;font-weight:bold;text-decoration:underline">资源负载</p>
      <p style="text-indent:2em">{{'YYYY' | bracketFilter}}年{{'MM' | bracketFilter}}月{{type === 'project' ? 'project' : 'domain' | bracketFilter}}{{type === 'project' ? '项目' : '域'}}虚拟机CPU平均使用率为{{'xx' | bracketFilter}}%, 虚拟机内存平均使用率为{{'xx' | bracketFilter}}%, 虚拟机磁盘平均使用率为{{'xx' | bracketFilter}}%，近6个月资源使用情况如下图所示:</p>
      <img :src="CpuUsageImg" alt="虚拟机CPU平均使用率" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <img :src="MemUsageImg" alt="虚拟机内存平均使用率" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <p style="font-size:22px;font-weight:bold;text-decoration:underline">优化建议</p>
      <p style="text-indent:2em">根据使用情况，我们建议对资源进行如下优化，预计每月能节省{{ currencySign }}{{'xx' | bracketFilter}}，每年能节省{{ currencySign }}{{'xx' | bracketFilter}}，建议列表TOP10如下图所示:</p>
      <table cellspacing="0" cellpadding="5" width="100%" style="color: #606266;border: solid 1px #ccc;">
        <tbody>
          <tr style="background: #AEE2FF;border: 1px solid #AEE2FF;color:black">
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">资源名称</th>
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">状态</th>
            <th align="left" style="border-right: solid 1px #ccc;border-bottom:solid 1px #ccc">优化建议</th>
            <th align="right" style="border-bottom:solid 1px #ccc">每月可节约</th>
          </tr>
          <template v-for="item in 10">
            <tr style="font-size: 14px" :key="item">
              <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">eip-for-vm1</td>
              <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">待处理</td>
              <td style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">释放未使用的弹性公网ip</td>
              <td style="border-bottom: 1px solid #ccc;text-align:right">{{ currencySign }} 100.23</td>
            </tr>
          </template>
        </tbody>
      </table>
      <p style="text-indent:2em;color:red">注：若有其它币种账单将以上述格式同步展示（此内容不会保存到模板中）</p>
    </div>
    <!-- 日报 域和项目报表 -->
    <div class="report-content" v-if="wholeType === 'daily' && (type === 'domain' || type === 'project')" title="此内容不支持编辑">
      <p style="text-indent:2em">此邮件为您所属的{{type === 'project' ? '项目' : '域'}} {{type === 'project' ? 'project' : 'domain' | bracketFilter}} 在{{'YYYY' | bracketFilter}}年{{'MM' | bracketFilter}}月{{'DD' | bracketFilter}}日费用及资源信息：</p>
      <p style="font-size:22px;font-weight:bold;text-decoration:underline">账单费用</p>
      <p style="text-indent:2em">{{'MM' | bracketFilter}}月{{'DD' | bracketFilter}}日费用{{ currencySign }}{{'xx' | bracketFilter}}, 近7日消费情况如下图所示：</p>
      <img :src="DailyPublicCostImg" alt="月费用" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <p style="text-indent:2em;color:red">注：若有其它币种账单将以上述格式同步展示（此内容不会保存到模板中）</p>
      <p style="font-size:22px;font-weight:bold;text-decoration:underline">资源类型消费明细</p>
      <p style="text-indent:2em">{{'YYYY' | bracketFilter}}年{{'MM' | bracketFilter}}月资源类型消费明细（{{ currencySign }}）如下表所示:</p>
      <table border="1" cellspacing="0" cellpadding="5" width="100%">
        <tbody>
          <tr>
            <th>日期</th>
            <th>资源类型</th>
            <th>金额</th>
            <!-- <th>占比</th> -->
          </tr>
          <template v-for="(row,index) in dailyTables">
            <tr style="font-size: 14px" :key="index">
              <td v-for="(col, idx) in row" :key="idx" :style="{textAlign: idx > 1 ? 'right' : 'center'}">{{col}}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <p style="text-indent:2em;color:red">注：若有其它币种账单将以上述格式同步展示（此内容不会保存到模板中）</p>
      <p style="font-size:22px;font-weight:bold;text-decoration:underline;margin-top:20px">资源负载</p>
      <p style="text-indent:2em">{{'YYYY' | bracketFilter}}年{{'MM' | bracketFilter}}月{{'DD' | bracketFilter}}日{{type === 'project' ? 'project' : 'domain' | bracketFilter}}{{type === 'project' ? '项目' : '域'}}虚拟机CPU平均使用率为{{'xx' | bracketFilter}}%, 虚拟机内存平均使用率为{{'xx' | bracketFilter}}%, 虚拟机磁盘平均使用率为{{'xx' | bracketFilter}}%，近7日资源使用情况如下图所示:</p>
      <img :src="CpuUsageImg" alt="虚拟机CPU平均使用率" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
      <img :src="MemUsageImg" alt="虚拟机内存平均使用率" style="display:block;margin-bottom:20px;width: 70%;margin-left: 15%" />
    </div>
  </div>
</template>

<script>
import DailyPublicCostImg from '@Reports/assets/daily_public_cost.png'
import PublicCostImg from '@Reports/assets/public_cost.png'
import CpuUsageImg from '@Reports/assets/cpu_usage.png'
import MemUsageImg from '@Reports/assets/mem_usage.png'
import { currencyUnitMap } from '@/constants/currency'

export default {
  name: 'ReportTemplateContent',
  filters: {
    bracketFilter (val) {
      return `{{ ${val} }}`
    },
  },
  props: {
    type: String,
    inSidepage: Boolean,
    wholeType: String,
  },
  data () {
    return {
      DailyPublicCostImg,
      PublicCostImg,
      CpuUsageImg,
      MemUsageImg,
      dailyTables: [
        ['2023-07-01', '', `${currencyUnitMap.CNY.sign}200`],
        ['', '虚拟机', `${currencyUnitMap.CNY.sign}20`],
        ['', '负载均衡', `${currencyUnitMap.CNY.sign}30`],
        ['', '硬盘', `${currencyUnitMap.CNY.sign}40`],
        ['', '弹性公网IP', `${currencyUnitMap.CNY.sign}10`],
        ['2023-07-02', '', `${currencyUnitMap.CNY.sign}150`],
        ['', '虚拟机', `${currencyUnitMap.CNY.sign}20`],
        ['', '负载均衡', `${currencyUnitMap.CNY.sign}30`],
        ['合计', '', `${currencyUnitMap.CNY.sign}350`],
      ],
      currencySign: currencyUnitMap.CNY.sign,
    }
  },
  computed: {
  },
  created () {

  },
  mounted () {
  },
  methods: {
  },
}
</script>

<style lang="less" scoped>
.report-tempalte-wrapper {
  min-height: 30px;
  .report-content {
    position: relative;
    padding: 15px;
  }
}

.no-edit {
  border: 1px solid #d9d9d9;
  .report-content:hover {
    opacity: 0.5;
  }
}
table {
  border-collapse: collapse;
  /* table-layout: fixed; */
  word-break: keep-all;
  color: #606266;
  border-color:#ccc;
  font-size: 14px;
}
th {
  background-color: #aee2ff!important;
  color: #000!important;
}
th,
td {
  padding: 3px 5px;
  text-align: center;
  width: 100px;
}
.align-right {
  text-align: right;
}
</style>
